import { videoAsset } from '@/data/sanity/fragments'
import { getMainDataOverrides, getLanguageQueryString } from '@/data/sanity/utils-language'

export const fields = `
  title, 
  'slug': slug.current,
  ...(content) {
    ${getLanguageQueryString(['publishedDate', 'linkType', 'link', { name: 'file', fields: videoAsset.fields }])}
  },
  ${getMainDataOverrides({
    objectSuffix: 'Content',
    mainObjectName: 'content',
    mainDataOverrides: ['title'],
  })}
`

export const fragment = (name: string) => `${name}{
	${fields}
}`

const exports = { fields, fragment }

export default exports
